import {useEffect, useState} from 'react';
import {defaultTheme} from '@stencil/build-theme';
import {useSelector} from 'react-redux';
import {FlexWrap} from '../../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import HappyTickMarkIcon from '@stencil/icons/src/HappyTickMarkIcon/HappyTickMarkIcon';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import PlanDetailsPoliciesModal from '../../../../../../../../stories/components/hotels/DetailsPageUnif/Rooms/Modal/PlanDetailsandPoliciesModal';
import HappyCloseIcon from '@stencil/icons/src/HappyCloseIcon/HappyCloseIcon';

import * as S from './UpsellComboInclusions.styles';

const UpsellComboInclusions = ({
  det_inc = [],
  rpt,
  // refundStatus,
  // refundStatusText = '',
  // refundStatusTextColor = '',
  cancellationPolicyTimeline,
  roomTypeNameData = '',
  cancellationPolicy = {},
}) => {
  const {
    isModalOpen: isPlanPoliciesModalOpen,
    openModal: openPlanPoliciesModal,
    closeModal: closePlanPoliciesModal,
  } = useModal();

  if (det_inc?.length == 0) return null;

  return (
    <S.UpsellInclusions>
      <S.UpsellRefund_text>{rpt}</S.UpsellRefund_text>
      {det_inc.map(item => {
        return (
          <S.UpsellInclusionsFlexWrap>
            <S.UpsellBulletCircle_Black />
            <S.UpsellFree_Checkin
              dangerouslySetInnerHTML={{
                __html: item?.text,
              }}
            />
          </S.UpsellInclusionsFlexWrap>
        );
      })}
      {cancellationPolicy?.type == 'NR' ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <HappyCloseIcon width="1rem" height="1rem" margin="0 0.8rem 0 0" fill={'#d0011b'} />
          <S.RoomRefundWrap>{cancellationPolicy?.text}</S.RoomRefundWrap>
        </div>
      ) : null}
      {cancellationPolicy?.type == 'FC' ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <HappyTickMarkIcon
            height="1rem"
            width="1rem"
            margin="0 0.8rem 0 0"
            fill={defaultTheme.colors.goGreen.base}
          />
          <S.RoomFreeCancellationWrap
            dangerouslySetInnerHTML={{
              __html: cancellationPolicy?.text,
            }}
          />
        </div>
      ) : null}
      <>
        <S.ViewMoreLink
          onClick={() => {
            openPlanPoliciesModal();
          }}
        >
          View plan details & policies
        </S.ViewMoreLink>
      </>

      {/* Plan Details and Policies Modal  */}
      <Modal
        isOpen={isPlanPoliciesModalOpen}
        closeModal={closePlanPoliciesModal}
        modalStyles={{width: '80rem'}}
        hideCloseButton={true}
      >
        <PlanDetailsPoliciesModal
          roomData={{
            amenities: det_inc,
            cancellationPolicy,
            cancellationPolicyTimeline,
            roomFlavorName: rpt,
            roomTypeNameData,
          }}
          onCloseBtnClick={closePlanPoliciesModal}
        />
      </Modal>
      {/* Plan Details and Policies Modal  */}
    </S.UpsellInclusions>
  );
};

export default UpsellComboInclusions;
